import { Component, OnInit } from '@angular/core';
import {Pages} from '@Interfaces/index';

@Component({
  selector: 'app-baja-bienes',
  templateUrl: './baja-bienes.component.html'
})
export class BajaBienesComponent implements OnInit {

  PAGES = Pages;

  constructor(
  ) { }

  /**
   * on init
   */
  ngOnInit() {
  }
}
